import "./NotificationsPane.css";
import {
  init_NotificationObject,
  NotificationObject,
} from "../../interfaces/APIInterface";
import { useContext, useState } from "react";
import NotificationFlyout from "./NotificationFlyout";
import { AdminContext } from "../../contexts/AdminContext";
import { useNavigate } from "react-router-dom";
import { isNullUndefEmpty } from "../../ts/common";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'notistack';
import { CardHeader } from "@mui/material";

interface NotificationPaneProps {
  showNotificationPane: boolean;
  setShowNotificationPane: React.Dispatch<React.SetStateAction<boolean>>;
  notificationList: Array<NotificationObject>;
  acknowledgeNotification: (
    notificationId: string,
    notificationApplication: string
  ) => Promise<boolean>;
}

const drawerWidth = '450px'

const NotificationsPane = (props: NotificationPaneProps) => {
  const [viewNotification, setViewNotification] = useState<boolean>(false);
  const [notificationToView, setNotificationToView] =
    useState<NotificationObject>(init_NotificationObject);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const {adminCredentials, getToken} = useContext(AdminContext);
  const isEmailRegex = /^[^@]+@[^@]+\.[^@]+$/;
  let navigate = useNavigate();

  const userRedirect = (navigateTo: { pathname: string; search: string }) => {
    setViewNotification(false);
    props.setShowNotificationPane(false);
    navigate(navigateTo);
  };

  const hidePane = () => {
    props.setShowNotificationPane(false);
  };

  const processNotification = async (id: string, applicationId: string) => {
  if(await props.acknowledgeNotification(id, applicationId)){
    enqueueSnackbar('Notification Acknowledged', {variant: 'success'})
  }
  else {
    enqueueSnackbar('Error notification was not acknowledged', {variant: 'error'})
  }
}

  return (
    <Drawer anchor="right" open={props.showNotificationPane} onClose={hidePane} sx={{width: drawerWidth, [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' }}}>
        <NotificationFlyout
          viewNotification={viewNotification}
          setViewNotification={setViewNotification}
          acknowledgeNotification={processNotification}
          note={notificationToView}
          userRedirect={userRedirect}
        />
      <Container>
        <Button
          sx={{marginTop: 4, marginBottom: 2}}
          className="full-width"
          onClick={hidePane}
          variant="outlined"
        >
          Hide
        </Button>
          {props.notificationList.length > 0 ? (
            <Stack>
                {props.notificationList.map((note: NotificationObject) => (
                  <Card
                  variant="outlined"
                    key={note.id}
                  >
                    <CardHeader disableTypography title={"Error | " + note.notificationType} />
                    
                    <CardContent>
                        <Typography variant='subtitle1'> {note.id} </Typography>
                        <Typography variant='body1'>
                          {" "}
                          Application: {
                            adminCredentials.allApplications[note.applicationId]?.name
                          }{" "}
                        </Typography>
                        {note.userId === undefined && note.userId === "" ? (
                          <></>
                        ) : !isEmailRegex.test(note.userId) ? (
                          <Typography variant='body1'>
                            User:{" "}
                            <Button
                              className="link-imitation"
                              onClick={() =>
                                userRedirect({
                                  pathname: `/edit-user`,
                                  search: `?user=${note.userId}&country=${note.country}`,
                                })
                              }
                            >
                              {!isNullUndefEmpty(note.userEmail) ? note.userEmail : !isNullUndefEmpty(note.userFirstName) && !isNullUndefEmpty(note.userLastName) ? note.userFirstName + ' ' + note.userLastName : note.userId}
                            </Button>
                          </Typography>
                        ) : (
                          <Typography variant='body1'>
                            Email Address:{" "}
                            <Button
                              className="link-imitation"
                              onClick={() =>
                                userRedirect({
                                  pathname: `/search-users`,
                                  search: `?email=${note.userId}`,
                                })
                              }
                            >
                              {note.userId}
                            </Button>
                          </Typography>
                        )}
                        <Typography variant='body1'>
                          {" "}
                          Time: {new Date(
                            note.tsCreatedAt * 1000
                          ).toLocaleString()}{" "}
                        </Typography>
                        <Typography variant='body1'>
                          {" "}
                          {note.notificationMessage}{" "}
                        </Typography>
                    </CardContent>
                      <CardActions>
                        <Button 
                        className="button"
                        variant="outlined"
                        onClick={() => {
                      setViewNotification(true);
                      setNotificationToView(note);
                    }}>
                      View Notification
                    </Button>
                        <Button
                          className="button"
                          variant="outlined"
                          onClick={() => {processNotification(note.id, note.applicationId);}
                          }
                        >
                          Acknowledge
                        </Button>
                      </CardActions>
                  </Card>
                ))}
                {props.notificationList && props.notificationList.length > 50 && (
                  <Button
                    className="link-imitation-normalcase"
                    onClick={() =>
                      userRedirect({
                        pathname: `/notifications`,
                        search: ''
                      })
                    }
                  >View all notifications</Button>
                )}
            </Stack>
          ) : (
            <h2>Nothing here!</h2>
          )}
      </Container>
    </Drawer>
  );
};

export default NotificationsPane;
